<template>
  <div class="page trivia generic">
    <GenericHeader />
    <main>
      <section class="genericContent">
        <h1 class="genericContent__heading">About Us</h1>
        <p>Trivia Pop is your daily dose of challenging pop culture trivia - And it’s free! Give it a shot and see if you can beat the crowd!</p>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import GenericHeader from "./GenericHeader.vue";
import SiteFooter from "../site/SiteFooter.vue";
import { mapState } from 'vuex';

export default {
  name: "About",
  components: {
    GenericHeader,
    SiteFooter
  },
  created() {
    this.$store.dispatch("GET_DATA");
  },
  computed: {
    ...mapState({
      siteData: state => state.data.site
    })
  }
};
</script>


